module.exports = __webpack_public_path__ + "img/docx.7fa3eaaa.svg";